<template>
    <div>
        <div class="loader-container" v-if="!loaded">
            <div class="loader"></div>
        </div>
        <b-list-group v-if="loaded">
            <b-list-group-item v-if="!lista_dottori.length && loaded" variant="secondary"><span>Non ci sono dottori da visualizzare.</span></b-list-group-item>
            <b-list-group-item button class="d-flex justify-content-between align-items-center list-item" v-for="dottore in lista_dottori" @click="navigate(dottore)" :key="dottore.uid">
                <span> {{dottore.last_name + " " + dottore.first_name}}</span>
                <span v-if="dottore.ultima_bolla"><small>Ultima Bolla: </small> {{format_date(dottore.ultima_bolla)}}</span>
            </b-list-group-item>
        </b-list-group>
    </div> 
</template>

<script>
import {mixins} from '@/mixins'

export default {
    name: "ListaDottori",
    data(){
        return{
            lista_data: [],
            loaded: false
        }
    },
    computed: {
        lista_dottori: function(){
            return this.lista_data;
        }
    },
    mixins: [mixins],
    mounted(){
        this.$axios
        .get(this.$apibase + "/api/users/get_dottori/", {
            headers: {
                Authorization:"JWT " + localStorage.getItem('access_token')
            }
        })
        .then(response => {
            this.lista_data = response.data;
            this.loaded = true;
        })
        .catch((e)=>{
            if (e.response.status == 403)
                this.logout();
            else
                alert(e);
        })
    },
    methods: {
        navigate: function(doc) {
            this.$store.dispatch('selectDottore', {nome: doc.first_name, cognome: doc.last_name, uid: doc.uid});
            this.$router.push('/dottore/' + doc.uid);
        }
    }
}
</script>

<style scoped>
    .list-item{
        padding-left: 40px;
        padding-right: 40px;
        color: #707070;
    }
    .body {
        padding-top: 35px;
        text-align: left;
    }
    .list{
        padding-top:40px;
    }
</style>